// src/components/ConfirmationModal.jsx

import React from 'react';

const ConfirmationModal = ({ title, message, confirmText, cancelText, onConfirm, onCancel }) => {
  return (
    <>
      <div className="settings-overlay" onClick={onCancel}></div>
      <div className="confirmation-modal">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="modal-footer">
          <button className="profile-button" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="profile-button profile-button--danger" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;